import Link from "next/link";
import React from "react";
import { StepProp } from "./Step1";
import { useVerifyOtpMutation } from "@/graphql/generated/schema";
import toast from "react-hot-toast";
import Button from "@/designs/Button";

const Step2 = ({ setSteps, otp, setOTP, email }: StepProp) => {
  const [verifyOtp, { loading }] = useVerifyOtpMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!otp) {
      toast.error("Please enter the OTP sent to your email.");
      return;
    }

    try {
      const { data } = await verifyOtp({
        variables: { email, otp },
      });

      const output = data?.verifyOtp;

      if (output?.user?.id) {
        toast.success(
          "OTP verified successfully."
        );
        setSteps(); // move to next step (reset password form)
      } else {
        toast.error(output?.error?.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to verify OTP. Please try again later.");
    }
  };

  return (
    <form className="space-y-5" onSubmit={handleSubmit}>
      <div>
        <label className="block text-sm font-medium  mb-1">
          OTP
        </label>
        <input
          type="text"
          inputMode="numeric"
          maxLength={4}
          placeholder="****"
          value={otp}
          onChange={(e) => setOTP && setOTP(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#004175] text-center tracking-widest"
        />
      </div>

      <div className="text-right text-sm">
        <Link href="/login" className="text-[#004175] hover:underline">
          Already have an account?
        </Link>
      </div>

      <Button type="submit" loading={loading}>
        Verify OTP
      </Button>
    </form>
  );
};

export default Step2;
